import React from 'react'

import { useTranslation } from 'react-i18next'

import operation from '../../../assets/operation.webp'
import { DiscoverMoreButton } from '../../../components/buttons/DiscoverMoreButton'
import { SectionText } from '../../../components/SectionText'
import { TableContent, TableRow } from '../../../components/TableRow'

interface SurgeryAndAmbulantProps {
    className?: string
}

export const SurgeryAndAmbulant: React.FC<SurgeryAndAmbulantProps> = ({ className }) => {
    const { t } = useTranslation()

    const LeftTableProps: TableContent = {
        classNameTr: 'flex',
        classNameTdLeft: 'flex bg-white justify-center text-9xl font-bold text-primary-green mr-6 xs:text-7xl',
        textColumnLeft: '1',
        textColumnRight: (
            <SectionText
                className="text-primary-green items-center justify-center"
                title={t('surgeryAndAmbulant.generalPediatricSurgery')}
                hrLineColor="bg-primary-green">
                <div>
                    <ul className="list-disc pl-5 mt-2">
                        <li>{t('surgeryAndAmbulant.conditions.abdominalPain')}</li>
                        <li>{t('surgeryAndAmbulant.conditions.urologicalProblems')}</li>
                        <ul className="list-disc pl-5">
                            <li>{t('surgeryAndAmbulant.conditions.enuresis')}</li>
                            <li>{t('surgeryAndAmbulant.conditions.urinaryInfections')}</li>
                        </ul>
                        <li>{t('surgeryAndAmbulant.conditions.constipation')}</li>
                        <li>{t('surgeryAndAmbulant.conditions.insectBites')}</li>
                    </ul>
                </div>
            </SectionText>
        ),
    }
    const RightTableProps: TableContent = {
        classNameTr: 'flex',
        classNameTdLeft: 'flex justify-center text-9xl font-bold text-white mr-6 pl-3 xs:pl-0 xs:text-7xl',
        textColumnLeft: '2',
        textColumnRight: (
            <div className="flex flex-col justify-center items-center">
                <SectionText
                    className="text-white px-3"
                    title={t('surgeryAndAmbulant.ambulatorySurgery')}
                    hrLineColor="bg-primary-green">
                    <div>
                        <ul className="list-disc pl-5 mt-2 text-white">
                            <li>{t('surgeryAndAmbulant.operations.hernia')}</li>
                            <li>{t('surgeryAndAmbulant.operations.hydrocele')}</li>
                            <li>{t('surgeryAndAmbulant.operations.umbilicalHernia')}</li>
                            <li>{t('surgeryAndAmbulant.operations.phimosis')}</li>
                            <li>{t('surgeryAndAmbulant.operations.moles')}</li>
                            <li>{t('surgeryAndAmbulant.operations.hemangiomas')}</li>
                            <li>{t('surgeryAndAmbulant.operations.skinTumors')}</li>
                            <li>{t('surgeryAndAmbulant.operations.warts')}</li>
                            <li>{t('surgeryAndAmbulant.operations.ingrownNails')}</li>
                            <li>{t('surgeryAndAmbulant.operations.lipAndTongueFrenulum')}</li>
                            <li>{t('surgeryAndAmbulant.operations.ganglion')}</li>
                            <li>{t('surgeryAndAmbulant.operations.digitDeformities')}</li>
                            <li>{t('surgeryAndAmbulant.operations.triggerThumb')}</li>
                            <li>{t('surgeryAndAmbulant.operations.scarCorrection')}</li>
                            <li>{t('surgeryAndAmbulant.operations.coccygealFistulas')}</li>
                            <li>{t('surgeryAndAmbulant.operations.materialRemoval')}</li>
                        </ul>
                    </div>
                </SectionText>
                <DiscoverMoreButton className="mt-5 bg-primary-orange -ml-24" link="/ambulant-operation" />
            </div>
        ),
    }
    return (
        <div
            className={`${className} container flex min-h-[700px]
            sm:h-auto sm:flex-col sm:justify-between sm:min-h-[1000px]
        `}>
            <table className="flex bg-white w-1/2 items-center justify-center sm:w-full sm:h-[400px] sm:px-3">
                <TableRow TableRowProps={LeftTableProps} />
            </table>
            <div className="w-1/2 flex items-center justify-center relative py-10 sm:w-full sm:h-auto sm:min-h-[700px] sm:px-5 sm:py-10">
                <img className="w-full h-full absolute object-cover object-bottom" src={operation} alt="ambulant-operation"></img>
                <table className="w-full h-full bg-primary-blue-faded flex items-center justify-center bg-opacity-50 z-10 absolute inset-0">
                    <TableRow TableRowProps={RightTableProps} />
                </table>
            </div>
        </div>
    )
}
